import { TeamUserRolesEnum } from "@/enums/team-user-role";
import { TeamDTO } from "@shaarp/common";

/** The teams a user can switch to, in the sections the switcher shows. */
export type SwitchableTeams = {
  /** The user's own teams. */
  readonly own: TeamDTO[];
  /** Teams the user advises. */
  readonly affiliated: TeamDTO[];
  /** Other customers' teams, reachable in admin mode for support. */
  readonly supported: TeamDTO[];
};

/** Sorts the user's teams into the switcher's sections. */
export function groupSwitchableTeams(
  teams: readonly TeamDTO[],
): SwitchableTeams {
  return {
    own: teams.filter(
      (team) => !team.external && team.userRole !== TeamUserRolesEnum.ADVISOR,
    ),
    affiliated: teams.filter(
      (team) => team.userRole === TeamUserRolesEnum.ADVISOR,
    ),
    supported: teams.filter((team) => team.external === true),
  };
}

/** Whether a team shows in the switcher: enabled, or disabled when asked for. */
export const isTeamListed = (
  team: TeamDTO,
  showsDisabled: boolean,
): boolean =>
  team.status === "enabled" || (showsDisabled && team.status === "disabled");
